import React from 'react';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface BusinessNameFieldProps {
    readOnly: boolean;
}

export const BusinessNameField: React.FC<BusinessNameFieldProps> = ({ readOnly = false }) => {
    const businessName = useBrokerDetailsStore((s) => s.businessName);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const changed = useBrokerFieldFieldChanged(FormField.BusinessName);

    return (
        <>
            <TextBox
                id='businessName'
                value={businessName}
                onChange={(v) => updateFields({ businessName: v })}
                label='Legal Name of Entity'
                width={'100%'}
                required={true}
                readOnly={readOnly}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
